export default {"src":"/_next/static/media/progress.colour.a66fc912.svg","height":366,"width":366,"blurWidth":0,"blurHeight":0};